export default "__VITE_ASSET__Bzodn4Jy__"